/* eslint camelcase: 0 */
import { Component } from 'preact'
import { createPortal } from 'preact/compat'
import { getInitialState } from '../../helpers/state'
import { Stars, ReviewForm, Modal } from '../'
import i18n from '../../i18n'
import {
  PROMPT_THRESHOLD,
  OPEN,
  CLOSED,
  PENDING,
  ERROR,
  AUTOSUBMIT_THESHOLD,
  AGGRESSIVE_CTA
} from '../constants'
import { submit } from '../helpers';
import CTA from './CTA'

export const CLASS = 'mv-reviews'

/**
 * Renders the rating UI in cards.
 */
class Ratings extends Component {
  constructor(props) {
    super(props)

    this.initialData = getInitialState(props.id)

    this.state = {
      localRating: this.initialData ? this.initialData.rating : null,
      status: CLOSED,
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleUpdateRatings = this.handleUpdateRatings.bind(this)
    this.renderInner = this.renderInner.bind(this)
    this.renderModal = this.renderModal.bind(this)
  }

  componentDidMount() {
    // All of this code only needs to execute if we're
    // displaying aggressive CTAs.
    if(!AGGRESSIVE_CTA) return

    // Append target div to after notes, or ingredients if notes doesn't exist
    const cardWrap = this.props.el.closest('.mv-create-wrapper')
    const insertAfter =
      cardWrap.querySelector('.mv-create-notes') ||
      cardWrap.querySelector('.mv-create-instructions')
    this.target = document.createElement('div')
    cardWrap.appendChild(this.target)
    cardWrap.insertBefore(this.target, insertAfter.nextSibling)
  }

  /**
   * Callback to handle a star selection. Modal opens if below threshold (default 5.5 aka always)
   * @param {number} localRating
   */
  async handleClick(rating) {
    const { id } = this.props

    if(rating >= AUTOSUBMIT_THESHOLD) {
      const res = await submit({ creation: id, rating })
      if(!res.ok) {
        this.setState({ status: ERROR })
        return
      }
    }

    if(rating >= PROMPT_THRESHOLD) {
      this.setState({ status: PENDING, localRating: rating })
    } else {
      this.setState({ status: OPEN, localRating: rating })
    }
  }

  /**
   * Callback after form submission. We close the modal and update ratings.
   * @param {number} rating    New rating
   * @param {object} previous  Locally-cached rating
   */
  handleUpdateRatings(review) {
    this.setState({ status: CLOSED })
    if (this.initialData) {
      const { id, onUpdate } = this.props
      onUpdate(id, review)
    } else {
      const { id, onAdd } = this.props
      onAdd(id, review)
    }
  }

  renderInner() {
    const { localRating } = this.state
    const { rating } = this.props

    return (
      <div>
        <Stars
          rating={localRating}
          globalRating={rating}
          onClick={this.handleClick}
        />
      </div>
    )
  }

  renderModal() {
    const { localRating } = this.state
    const { id } = this.props
    return (
      <Modal onClose={() => this.setState({ status: CLOSED })}>
        <ReviewForm
          id={id}
          initial={this.initialData}
          rating={localRating}
          onSubmit={this.handleUpdateRatings}
        />
      </Modal>
    )
  }

  render() {
    const { status } = this.state
    const { total, rating } = this.props

    if(this.cardThemeSupportsTopLevelCTA) {
      return (
        <div>
          <CTA onClick={() => this.setState({ status: OPEN })}>
            {this.renderInner()}
          </CTA>

          {status === OPEN && (
            this.renderModal()
          )}
        </div>
      )
    }

    return (
      <div class={`${CLASS}`}>

        {this.renderInner()}

        <div class={`${CLASS}-reviewcount`}>
          {/* If we have reviews, render the counts. If not, fallback to "no ratings" message. */}
          {Number(total) ? (
            <span>
              {i18n('NUM_STARS')(parseFloat(rating).toFixed(1))}
              {' ('}
              {total > 1 ? i18n('NUM_REVIEWS')(total) : i18n('NUM_REVIEW')(total)}
              {')'}
            </span>
          ) : i18n('NO_RATINGS')}
        </div>

        {status === ERROR && (
          <div>{i18n('GENERIC_ERROR')}</div>
        )}

        {status === PENDING && (
          <button onClick={() => this.setState({ status: OPEN })}>
            {i18n('THANKS_RATING')} {i18n('LEAVE_REVIEW')}
          </button>
        )}

        {status === OPEN && (
          this.renderModal()
        )}

        {this.target && !this.initialData && (
          // Render the in-card CTA only if there wasn't initial data for the card
            createPortal(
              <CTA onClick={() => this.setState({ status: OPEN })}>
              {this.renderInner()}
              </CTA>,
              this.target
            )

        )}

      </div>

    )
  }
}

export default Ratings
